module.exports = __webpack_public_path__ + "static/img/delivery_off.692952fa.svg";